module.exports = __webpack_public_path__ + "img/APA 1978.84af4f9d.png";